import React, { Fragment } from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Pagination, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import RadioQuestionPreview from '../../QuestionPreviews/RadioQuestionPreview';
import AnswerQuestionPreview from '../../QuestionPreviews/AnswerQuestionPreview';
import OfferedMultipleAnswerQuestionPreview from '../../QuestionPreviews/OfferedMultipleAnswerQuestionPreview';
import SliderQuestionPreview from '../../QuestionPreviews/SliderQuestionPreview';
import OfferedAnswerQuestionPreview from '../../QuestionPreviews/OfferedAnswerQuestionPreview';
import DateQuestionPreview from '../../QuestionPreviews/DateQuestionPreview';
import OfferedMultipleAnswerQuestionCommentPreview
    from '../../QuestionPreviews/OfferedMultipleAnswerQuestionCommentPreview';
import OfferedAnswerQuestionCommentPreview from '../../QuestionPreviews/OfferedAnswerQuestionCommentPreview';


export default class AdminPollPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: true,
            section: []

        };
        this.getPollQuestionsById = this.getPollQuestionsById.bind(this);
        this.fetchQuestionSections = this.fetchQuestionSections.bind(this);
        this.getDefaultQuestionByPollId = this.getDefaultQuestionByPollId.bind(this);
    }
    componentDidMount() {
        this.fetchQuestionSections(JSON.parse(localStorage.getItem('poll')).pollType);
    }


    fetchQuestionSections(pollTypeId) {
        axios.get(`/questionnaire/get-sections/${pollTypeId}/`)
            .then(res => {
                const sections = res.data.map(el => ({
                    value: el.id,
                    key: el._key,
                    orderNumber: parseInt(el.orderNumber, 10),
                    text: el.displayName
                }));
                this.setState({ sections: sections.sort((a, b) => a.orderNumber - b.orderNumber) }, () => console.log('sekcije: ', this.state.sections));
            }).then(() => {
                this.getPollQuestionsById(JSON.parse(localStorage.getItem('poll')).pollId);
            })
            .catch(err => {
                console.log('Failed to fetch question sections.');
            });
    }
    // fix func name from getPollQuestionsById to getQuestionsByPollId
    getPollQuestionsById(id) {
        axios.get(`/questionnaire/all/questions/${id}/`)
            .then(res => {
                const pollQuestions = res.data;
                this.setState({
                    pollQuestions,
                });
            }).then(() => {
                this.getDefaultQuestionByPollId();
            }).catch(err => {
                this.setState({ loader: false });
                toast('Došlo je do greške. Nije moguće prikazati pitanja.');
                console.log('Failed to fetch question.');
            });
    }
    getDefaultQuestionByPollId() {
        axios.get(`/questionnaire/all/default-questions/${JSON.parse(localStorage.getItem('poll')).pollId}/`)
            .then(res => {
                const defaultQuestions = res.data;
                this.setState({
                    pollQuestions: [...this.state.pollQuestions, ...defaultQuestions],
                    loader: false
                });
            }).catch(() => {
                toast('Došlo je do greške. Nije moguće prikazati defaultna pitanja.');
                this.setState({ loader: false });
                console.log('Failed to fetch default question.');
            });
    }

    render() {
        let { pollQuestions, sections } = this.state;
        return (

            <Fragment>
                {this.state.loader ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader size="medium" active /></div> : pollQuestions ?
                    sections.map(section => (
                        <SectionPreview
                            update={this.getPollQuestionsById}
                            sectionDisplayName={section.text}
                            sectionQuestionList={pollQuestions.filter(question => section.key === question.question.section._key)}
                        />


                    ))
                    : 'Anketa nema pitanja!'}
                <ToastContainer hideProgressBar />
            </Fragment>
        );
    }
}


AdminPollPreview.propTypes = {


};
class SectionPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
        this.deleteQuestion = this.deleteQuestion.bind(this);
    }
    componentDidMount() {

    }
    deleteQuestion(id) {
        let obj = {
            question: { id },
            questionnaire: { id: JSON.parse(localStorage.getItem('poll')).pollId }
        };
        axios.delete('question/delete/', { data: obj })
            .then(res => {
                this.props.update(JSON.parse(localStorage.getItem('poll')).pollId);
                toast('Uspješno ste obrisali pitanje.');
            })
            .catch(err => {
                toast('Došlo je do greške. Brisanje pitanja nije uspjelo.');
            });
    }

    render() {
        let { sectionDisplayName, sectionQuestionList } = this.props;
        return (

            <Fragment>
                <Header as="h3">Sekcija: {sectionDisplayName}</Header>
                <div> {sectionQuestionList.length !== 0 ? sectionQuestionList.map((e) => {
                    if (e.question.questionType.name === 'select') {
                        return <Segment > <RadioQuestionPreview text={e.question.text} np={e.question.cannotRate} from={e.question.scaleFrom} to={e.question.scaleTo} typeId={e.question.questionType.id} questionId={e.question.id} deleteQuestion={this.deleteQuestion} showDeleteButton={localStorage.getItem('delete')} />  </Segment>;
                    }
                    if (e.question.questionType.name === 'tekst') {
                        return <Segment ><AnswerQuestionPreview text={e.question.text} typeId={e.question.questionType.id} questionId={e.question.id} deleteQuestion={this.deleteQuestion} showDeleteButton={localStorage.getItem('delete')} /></Segment>;
                    }
                    if (e.question.questionType.name === 'više odgovora') {
                        return <Segment ><OfferedMultipleAnswerQuestionPreview text={e.question.text} answerOptions={e.questionOptions} typeId={e.question.questionType.id} questionId={e.question.id} deleteQuestion={this.deleteQuestion} showDeleteButton={localStorage.getItem('delete')} /></Segment>;
                    }
                    if (e.question.questionType.name === 'više odgovora sa komentarom') {
                        return <Segment ><OfferedMultipleAnswerQuestionCommentPreview text={e.question.text} answerOptions={e.questionOptions} typeId={e.question.questionType.id} questionId={e.question.id} deleteQuestion={this.deleteQuestion} showDeleteButton={localStorage.getItem('delete')} /></Segment>;
                    }
                    if (e.question.questionType.name === 'slajder') {
                        return <Segment > <SliderQuestionPreview text={e.question.text} from={e.question.scaleFrom} to={e.question.scaleTo} typeId={e.question.questionType.id} questionId={e.question.id} deleteQuestion={this.deleteQuestion} showDeleteButton={localStorage.getItem('delete')} /></Segment>;
                    }
                    if (e.question.questionType.name === 'jedan odgovor') {
                        return <Segment > <OfferedAnswerQuestionPreview text={e.question.text} answerOptions={e.questionOptions} typeId={e.question.questionType.id} questionId={e.question.id} deleteQuestion={this.deleteQuestion} showDeleteButton={localStorage.getItem('delete')} /></Segment>;
                    }
                    if (e.question.questionType.name === 'jedan odgovor sa komentarom') {
                        return <Segment > <OfferedAnswerQuestionCommentPreview text={e.question.text} answerOptions={e.questionOptions} typeId={e.question.questionType.id} questionId={e.question.id} deleteQuestion={this.deleteQuestion} showDeleteButton={localStorage.getItem('delete')} /></Segment>;
                    }
                    if (e.question.questionType.name === 'datum') {
                        return <Segment ><DateQuestionPreview text={e.question.text} typeId={e.question.questionType.id} questionId={e.question.id} deleteQuestion={this.deleteQuestion} showDeleteButton={localStorage.getItem('delete')} /></Segment>;
                    }
                }) : 'Nema pitanja'}</div>
                <ToastContainer hideProgressBar />
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/PollPreviewTabs/PollPreview/AdminPollPreview.js